import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker, useJsApiLoader  } from '@react-google-maps/api';
import { Card, Fade, Grid, Hidden, Icon, IconButton, Typography } from '@material-ui/core';
import android_logo from '../assets/images/android.png'
import { format } from 'date-fns';
import { blueGrey, grey } from '@material-ui/core/colors';
import LoadingContainer from './LoadingContainer';
import { config } from '../utils/config';
//import format from 'date-fns/format';
const GOOGLE_API_KEY = config.GOOGLE_API_KEY//'AIzaSyCHWhnr3c_yrB6EJt6FzbXK1RSVQEBk2Q0'
const containerStyle = {width: '100%',height: '450px'};

const GoogleMapContainer = ({data, loading, mapsHidden, onChangeVisible}) => {

    const { isLoaded, loadError } = useJsApiLoader({googleMapsApiKey: GOOGLE_API_KEY})
    const [center, setCenter] = useState({lat:34.1139, lng:116.3300100})
    const [position, setPosition] = useState({lat:34.1139, lng:116.3300100})
    const [image, setImage] = useState(null)

    useEffect(() => {
        if(JSON.stringify(data) !== "{}"){
            const data2send = {lat: data.latitude, lng:data.longitude}
            setCenter(data2send)
            setPosition(data2send)
            //console.log(data)
            if(data.osImageUrl) setImage(data.osImageUrl)
        }
    }, [data])

    const onLoad = marker => {
        //console.log('marker: ', marker)
    }

    let last_connection_datetime = ''
    if(data){
        const datetime = new Date(data.dateTime)

        if(datetime instanceof Date && !isNaN(datetime)){
            last_connection_datetime = `${format(datetime, 'MM-dd-yyyy   HH:mm:ss')}h`
        }
    }
    


    return ( 
        <div>
            
            {!mapsHidden ? <Fade in>
                <div>
                    <Grid container alignItems='center' spacing={1}>
                        <Grid item>
                            <IconButton size='small' onClick={() => onChangeVisible(true)}><Icon>arrow_back_ios_new</Icon></IconButton>
                        </Grid>
                        <Grid item xs>
                            <Typography variant='h6' style={{
                            fontFamily:'Roboto',
                            color:'#455a64 ',
                            fontSize:21,
                            fontWeight:700, 
                            marginTop:16, 
                            lineHeight:1,
                            marginBottom:0}}>
                            Last connection
                        </Typography>
                        <Typography
                            style={{
                                color:blueGrey[300],
                                fontWeight:500,
                                fontSize:16,
                                marginBottom:4
                            }}
                        
                        >{last_connection_datetime}</Typography>
                        </Grid>
                    </Grid>
                    <Card style={{boxShadow:'0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'}}>
                        {isLoaded ? (
                            <div style={{position:'relative', width:'100%', minHeight:containerStyle.minHeight}}>
                                <LoadingContainer loading={loading}/>
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    center={center}
                                    zoom={15}>
                                        <>
                                            <Marker 
                                            icon={image}
                                            onLoad={onLoad}
                                            position={position}
                                            />
                                        </>
                                </GoogleMap>
                        </div>
                        ) : null}
                    </Card>
                </div>
                
            </Fade> : (
                <Fade in={mapsHidden}>
                        <Card style={{boxShadow:'0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'}}>
                            <div style={{position:'relative', width:'100%', height:520}}>
                                <div style={{position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}>
                                    <div style={{cursor:'pointer'}}  onClick={() => onChangeVisible(false)}>
                                        <Grid container alignItems='center' wrap='nowrap'>
                                            <Grid item>
                                                <Icon>
                                                    location_on
                                                </Icon>
                                            </Grid>
                                            <Grid item>
                                                <Icon fontSize='small'>
                                                arrow_forward_ios
                                                </Icon>
                                            </Grid>
                                        </Grid>
                                    </div>
                                    
                                </div>
                            </div>
                        </Card>
                    
                </Fade>
            ) }
            
            
            
        </div>
     );
}
 
export default GoogleMapContainer;